module.exports = __webpack_public_path__ + "img/cm.5f219fa7.svg";